import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CheckoutIntroComponent } from './checkout-intro.component';
var CheckoutIntroModule = /*@__PURE__*/ (function () {
    function CheckoutIntroModule() {
    }
    return CheckoutIntroModule;
}());
export { CheckoutIntroModule };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-intro/checkout-intro.module.ts
// module id = null
// module chunks = 